import { render, staticRenderFns } from "./NavigationSettings.vue?vue&type=template&id=0f32921d&"
import script from "./NavigationSettings.vue?vue&type=script&lang=js&"
export * from "./NavigationSettings.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports